// DynamicImportHelper.ts

// Define a type for the module structure
type ModuleType = {
  [key: string]: unknown
}

// Use a more specific type for the import.meta.glob result
const modules: Record<string, ModuleType> = import.meta.glob(
  '../components/GamePlay/Games/**/data/copy.ts',
  { eager: true }
)

function createRequireContext(modules: Record<string, ModuleType>): {
  (key: string): ModuleType | null
  keys: () => string[]
} {
  const context = (key: string): ModuleType | null => {
    // Normalize the path to handle both Unix and Windows-style paths
    const normalizedKey = key.replace(/\\/g, '/')

    // Create the full path pattern we're looking for
    const searchPattern = normalizedKey.startsWith('./')
      ? normalizedKey.slice(2) // Remove leading './'
      : normalizedKey

    // Debug logging
    console.log('Searching for path containing:', searchPattern)

    // Find the matching module path
    const fullPath = Object.keys(modules).find((path) => {
      // Normalize the path for comparison
      const normalizedPath = path.replace(/\\/g, '/')
      console.log('Checking path:', normalizedPath, 'includes:', searchPattern)
      return normalizedPath.includes(searchPattern)
    })

    // Debug logging for the result
    console.log('Found matching path:', fullPath)

    if (!fullPath) {
      console.warn(`No module found for key: ${key}`)
      console.warn('Available modules:', Object.keys(modules))
      return null
    }

    return modules[fullPath]
  }

  context.keys = (): string[] => {
    return Object.keys(modules).map((key) => {
      const normalizedKey = key.replace(/\\/g, '/')
      return normalizedKey.replace('../components/GamePlay/Games/', './')
    })
  }

  return context
}

const gamePlayModules = createRequireContext(modules)

export default gamePlayModules
